import { SyncIndicator } from "@internal/ui";
import { useObservable } from "@/hooks/useObservable";
import { syncState$ } from "@/lib/replication";

const INITIAL = {
  connection: "connected" as const,
  pending: false,
  lastInSyncAt: null as string | null,
};

export interface SyncStatusProps {
  /**
   * Render nothing while everything is connected and saved. Used on the
   * child screens, which have no header to hold a permanent status line and
   * whose users are not the ones deciding when it is safe to close the app.
   */
  degradedOnly?: boolean;
}

export function SyncStatus({ degradedOnly = false }: SyncStatusProps) {
  const { connection, pending, lastInSyncAt } = useObservable(
    syncState$,
    INITIAL,
  );

  if (degradedOnly && connection === "connected" && !pending) return null;

  return (
    <SyncIndicator
      connection={connection}
      pending={pending}
      lastInSyncAt={lastInSyncAt}
      data-testid="sync-indicator"
    />
  );
}
